module.exports = __webpack_public_path__ + "static/media/hamburger-outline.6cd0e1c2.svg";